import { env } from "./env";

export interface ApiOptions extends Omit<RequestInit, "body"> {
  body?: unknown;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly detalhes?: unknown,
  ) {
    super(message);
  }
}

export async function apiFetch<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const { body, headers, ...rest } = options;
  const url = `${env.apiUrl}${path}`;

  const requestHeaders = new Headers(headers);
  if (body !== undefined) requestHeaders.set("Content-Type", "application/json");

  const init: RequestInit = {
    ...rest,
    headers: requestHeaders,
    credentials: "include",
  };
  if (body !== undefined) init.body = JSON.stringify(body);

  const resposta = await fetch(url, init);

  if (!resposta.ok) {
    let detalhes: unknown;
    let mensagem = resposta.statusText;
    let codigo = `http_${resposta.status}`;
    try {
      const json = (await resposta.json()) as {
        // ProblemDetails RFC 7807 (formato do backend .NET)
        title?: string;
        detail?: string;
        errors?: unknown;
        // formato legado
        error?: string;
        message?: string;
        detalhes?: unknown;
      };
      if (json.detail) mensagem = json.detail;
      else if (json.message) mensagem = json.message;
      if (json.title) codigo = json.title;
      else if (json.error) codigo = json.error;
      detalhes = json.detalhes ?? json.errors;
    } catch {
      /* corpo nao era JSON */
    }
    // HTTP/2 nao tem reason phrase — statusText vem vazio; garante mensagem util.
    if (!mensagem || !mensagem.trim()) mensagem = `Erro ${resposta.status}. Tente novamente.`;
    throw new ApiError(resposta.status, codigo, mensagem, detalhes);
  }

  if (resposta.status === 204) return undefined as T;
  return (await resposta.json()) as T;
}
